import React, { forwardRef } from "react";
import { HTMLAttributes } from "react";
import { useCombinedThemeMode } from "../../../util/theme/useCombinedThemeMode";
import { TooltipContainerStyled } from "../styled/TooltipContainerStyled";

export interface TooltipContainerProps extends HTMLAttributes<HTMLDivElement> {
    squareCorner?: "borderTopLeft" | "borderTopRight" | "borderBottomLeft" | "borderBottomRight";
}

/**
 * This component is mostly for presentation, and is exposed to our consumers in case they want to
 * use these styles in their own components. Generally, that has taken the form of a custom Flyout
 * so it can have interactive elements inside of it.
 */
export const TooltipContainer = forwardRef<HTMLDivElement, TooltipContainerProps>(
    ({ children, squareCorner = undefined, ...rest }, ref) => {
        const themeMode = useCombinedThemeMode();
        return (
            <TooltipContainerStyled {...rest} squareCorner={squareCorner} themeMode={themeMode} ref={ref}>
                {children}
            </TooltipContainerStyled>
        );
    }
);

TooltipContainer.displayName = "TooltipContainer";
